import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { formatApiErrorDetail } from "../lib/api";
import { Logo } from "../components/Logo";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-brand-ceruleanDark flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-6"><Link to="/"><Logo light className="justify-center" /></Link></div>
        <div className="bg-white rounded-2xl shadow-2xl p-8">
          <h1 className="font-serif text-2xl text-brand-navy">Owner Console</h1>
          <p className="text-sm text-brand-slate mt-1 mb-6">Sign in to manage bookings & operations.</p>
          <form onSubmit={submit} className="space-y-4">
            <div><Label>Email</Label><Input data-testid="login-email-input" type="email" value={email} onChange={(e)=>setEmail(e.target.value)} className="mt-1" required /></div>
            <div><Label>Password</Label><Input data-testid="login-password-input" type="password" value={password} onChange={(e)=>setPassword(e.target.value)} className="mt-1" required /></div>
            {error && <p data-testid="login-error" className="text-sm text-brand-coral">{error}</p>}
            <Button data-testid="login-submit-btn" type="submit" disabled={loading} className="w-full bg-brand-cerulean hover:bg-brand-ceruleanDark text-white rounded-full">
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : "Sign In"}
            </Button>
          </form>
          <div className="mt-4 text-center">
            <Link to="/forgot-password" data-testid="forgot-password-link" className="text-sm text-brand-cerulean hover:underline">Forgot password?</Link>
          </div>
        </div>
        <div className="text-center mt-5"><Link to="/" className="text-sm text-white/70 hover:text-white">← Back to website</Link></div>
      </div>
    </div>
  );
}
